const Services = () => {
  return (
    <section
      id="services"
      data-nav-tooltip="Services"
      className="pp-section pp-scrollable section"
    >
      <div className="container">
        <div className="title">
          <h3>Qué hago?</h3>
        </div>
        <div className="row">
          <div className="col-sm-6 m-15px-tb">
            <div className="feature-box-01 media">
              <i className="icon theme-bg ti-notepad" />
              <div className="feature-content media-body">
                <h5>Analisis y Planificación</h5>
                <ul>
                  <li>Comprender y analizar los requisitos del usuario o las necesidades del negocio.</li>
                  <li>Colaborar con las partes interesadas para definir las especificaciones de software.</li>
                  <li>Planificar el proceso de desarrollo de software, con capacidad de adaptarse a las tecnologías emergentes.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-sm-6 m-15px-tb">
            <div className="feature-box-01 media">
              <i className="icon theme-bg icon-desktop" />
              <div className="feature-content media-body">
                <h5>Codificación y Desarrollo</h5>
                <ul>
                  <li>Escribir código utilizando lenguajes de programación como PHP y JavaScript con sus diferentes Frameworks.</li>
                  <li>utilizar herramientas y marcos de desarrollo para crear aplicaciones de software.</li>
                  <li>Implementar algoritmos y estructuras de datos para lograr la funcionalidad deseada.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-sm-6 m-15px-tb">
            <div className="feature-box-01 media">
              <i className="icon theme-bg ti-face-smile" />
              <div className="feature-content media-body">
                <h5>Fitness y Entrenamiento</h5>
                <ul>
                  <li>Realizar clases de fitness grupal asegurando el correcto desempeño de estas y la participación activa de los involucrados, logrando sensación de empoderamiento, entretenimiento y felicidad en ellos.</li>
                  <li>Planifico y ejecuto entrenamientos personalizados para lograr eficientemente los objetivos propuestos, brindando correcciones técnicas y acompañamiento constante.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-sm-6 m-15px-tb">
            <div className="feature-box-01 media">
              <i className="icon theme-bg ti-thumb-up" />
              <div className="feature-content media-body">
                <h5>Colaboración</h5>
                <ul>
                  <li>Trabajar en estrecha colaboración con otros miembros del equipo, fomentando un ambiente de colaboración.</li>
                  <li>Participar en revisiones de código para garantizar la calidad del código y el cumplimiento de los estándares de codificación.
                  </li>
                  <li>Contribuir en reuniones de equipo para impulsar la innovación y la eficiencia en el desarrollo de proyectos.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* <div className="col-sm-6 m-15px-tb">
            <div className="feature-box-01 media">
              <i className="icon theme-bg ti-rocket" />
              <div className="feature-content media-body">
                <h5>Deployment and Maintenance</h5>
                <ul>
                  <li>Deploy software applications to production environments.</li>
                  <li>Provide ongoing support and maintenance, including addressing issues and implementing updates.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-sm-6 m-15px-tb">
            <div className="feature-box-01 media">
              <i className="icon theme-bg ti-crown" />
              <div className="feature-content media-body">
                <h5>Continuous Learning</h5>
                <ul>
                  <li>Stay up-to-date with the latest technologies, programming languages, and development trends.</li>
                  <li>Continuously improve coding skills and adopt best practices.</li>
                </ul>
              </div>
            </div>
          </div> */}
        </div>
        
      </div>
    </section>
  );
};
export default Services;
